// extracted by mini-css-extract-plugin
var _1 = "oH2W7";
var _2 = "pRyEG";
var _3 = "WKV4l";
var _4 = "Ejrkd";
var _5 = "K3Sti";
var _6 = "U2XB8";
var _7 = "L9Agk";
var _8 = "gy2aJ";
var _9 = "_rWRU";
var _a = "r0IgA";
var _b = "o7SCB";
export { _1 as "compactTypeRampUpdates", _2 as "firstLineMultiColumnTypeRamp", _3 as "firstLineMultilineColumnTypeRamp", _4 as "full", _5 as "fullTypeRampUpdates", _6 as "medium", _7 as "mediumTypeRampUpdates", _8 as "messageListMajorTextNext", _9 as "messageListMinorTextNext", _a as "win32FirstLineText", _b as "win32MajorText" }
